import { Fragment, useEffect, useState } from "react";
import { Button, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { DonorService } from "../../Services/Donor.Service";
import { AdminService } from "../../Services/Admin.service";
import { formatDate, formatTime, formatCurrency } from "../../Utils/Common";
import Loader from "../../Components/Loader";

function ChangeAppointmentTime({
    show,
    onHide,
    onConfirm,
    appointment_id
}) {

    const [loading, setLoading] = useState(true);
    const [selectedJob, setSelectedJob] = useState(null); // Track selected radio button
    const [errorMessage, setErrorMessage] = useState(""); // Track error message
    const [viewJobId, setViewJobId] = useState(null);
    const [viewJob, setViewJob] = useState(null);
    const [samples, setSamples] = useState([]);

    useEffect(() => {
        fetchAnotherAppointmentList(appointment_id);
    }, [appointment_id]);

    //   selectedRoles, searchEmail, searchPhone, searchId
    const [jobList, setJobList] = useState([]);
    function fetchAnotherAppointmentList(appointment_id) { 
        setLoading(true);
        const params = { 
            appt_id: appointment_id
        }; 
        DonorService.anotherAppointmentList(params)
        .then((response) => {
            setJobList(response.available_slot); 
        })
        .catch((error) => {
            console.error("Failed to fetch available slots", error);             
        }).finally(() => {
            setLoading(false);
        });

    }

    useEffect(() => {
        fetchSampleTypes();
    }, []);

    async function fetchSampleTypes() {
        AdminService.getSampleTypes()
        .then((sampleTypes) => {
            setSamples(sampleTypes);
        })
        .catch((error) => {
            console.error("Failed to fetch sample types", error);
        });
    }

    const handleRadioChange = (job) => {
        setSelectedJob(job); 
        setErrorMessage(""); 
    };

    const handleViewDetails = () => {
        if (selectedJob == null) {
            setErrorMessage("Please select a time to reschedule your appointment.");
        } else {
            setErrorMessage(""); // Clear error if the correct radio button is selected
        }
    };
    return (

        <>
            <Loader loading={loading}/>
            <Modal show={show} centered onHide={onHide} dialogClassName="el-deactivate-modal el-change-appointment-time-modal" backdrop="static">

                <Modal.Body className="text-center">
                    {(!jobList || typeof jobList == 'undefined' || jobList.length === 0) && (
                        <div className="row col-12 p-5" style={{ border: '1px solid grey', borderRadius: '5px' }}>
                            <h6>No alternative time available for this job.</h6> 
                        </div>
                    )}

                    {jobList && typeof jobList !== 'undefined' && jobList.length> 0 && (
                        <div className="el-bg-table mb-4" style={{border:'1px solid lightgrey'}}>                        
                            <>

                                {jobList.map((job, index) => (
                                    <>
                                    <div key={index}>
                                        <div className="row align-items-center p-3">
                                            <div className="col-12 col-md-1 d-flex justify-content-center mb-2 mb-md-0">
                                                <input
                                                    type="radio"
                                                    className="form-check-input radio-pointer" 
                                                    name="jobSelection"                                        
                                                    value={job.interval_id}
                                                    id={`job-${appointment_id}-${index}`}
                                                    onChange={() => handleRadioChange(job)}
                                                />
                                                <label htmlFor={`job-${appointment_id}-${index}`} className="ms-2 radio-pointer"></label>
                                            </div>

                                            {/* Date */}
                                            <div className="col-12 col-md-3 mb-2 mb-md-0 text-center text-md-start">
                                                {formatDate(job.sample_pickup_date)}
                                            </div>

                                            {/* Time */}
                                            <div className="col-12 col-md-2 mb-2 mb-md-0 text-center text-md-start">
                                                {formatTime(job.time_interval)}
                                            </div>

                                            {/* Location */}
                                            <div className="col-12 col-md-3 mb-2 mb-md-0 text-center text-md-start">
                                                {job.lab_name}
                                            </div>

                                            {/* Sample ID */}
                                            <div className="col-12 col-md-2 mb-2 mb-md-0 text-center text-md-start">
                                                <SampleType sampletype={job.sample_ids} sampletypes={samples} />
                                            </div>

                                            {/* Compensation */}
                                            <div className="col-12 col-md-1 mb-2 mb-md-0 text-center text-md-start">
                                                {formatCurrency(job.total_sample_cost)}
                                            </div>
                                        </div>
                                    </div>
                                        {jobList && typeof jobList !== 'undefined' && index < jobList.length - 1 && (
                                            <div style={{ textAlign: 'center', margin: '10px 0', color: 'lightgrey' }}>
                                                <hr />
                                            </div>
                                        )}
                                    </>
                                ))}                        
                            </>
                        </div>
                    )}

                    <div className="text-danger mt-2"style={{ height: "1.5em"}} >
                        { errorMessage }
                    </div>
                    <div className="d-flex my-3  ">

                        {jobList && typeof jobList !== 'undefined' && jobList.length > 0 && (
                            <>
                            <button variant="outline-primary" className="el-main-button" onClick={()=> {
                                if(selectedJob==null){
                                    handleViewDetails();
                                    return
                                }
                                onConfirm({appt_id: appointment_id, interval_id: selectedJob.interval_id, request_id: selectedJob.request_id, price: selectedJob.total_sample_cost})}
                            }
                            >
                                <span> {"Accept New Time"}   </span>
                            </button>

                            </>
                        )}
                        <button variant="outline-primary" className="back-link ms-3" onClick={() => {
                            setSelectedJob();
                            setErrorMessage("");
                            onHide();
                        }}>
                            {"Close"}
                        </button>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );


}

export default ChangeAppointmentTime



function SampleType({ sampletype, sampletypes }) {
    const sampleIds = sampletype ? sampletype?.split(',').map(id => id.trim()) : [];
    return (<>

        <div className="el-icons-bg-box">
            {sampleIds?.length > 0 ? (
                sampleIds?.map((sampleId) => {
                    const sampleType = sampletypes?.find((type) => type.id === sampleId);
                    return sampleType ? (

                        <Fragment key={sampleId}>
                            {sampleIds?.length == 1 ? (<><div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div> </>) : (<><OverlayTrigger
                                key={sampleId}
                                placement="top"
                                overlay={
                                    <Popover id={`popover-${sampleId}`}>
                                        <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                    </Popover>
                                }
                            >
                                {/* {sampleIds.length == 1 ? (<div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div>) :  ( */}
                                <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                    <i className={sampleType.className}></i>
                                </Button>
                                {/* )}  */}
                            </OverlayTrigger>
                            </>)}


                        </Fragment>
                    ) : null;
                })
            ) : (
                "No samples available"
            )}
        </div>
    </>);
}
